const {
  event,
  event: { delegate, stop, undelegate, whichTransitionEndEvent }
} = window.o_util;

export { delegate, event, stop, undelegate, whichTransitionEndEvent };
/*                              */
